<template>
  <div id="func-53">
    <dialog-default
      v-if="erro.show"
      :show-close="false"
      custom-class="dialog-confirmar"
      :title="erro.titulo"
      :open.sync="erro.show"
      width="47%"
    >
      <span>{{erro.descricao}}</span>
    </dialog-default>
    <div id="confirmacao">
      <span class="title-info">{{textoConfirmacao}}</span>
      <span class="title-cards">Tipo da Consulta</span>
      <div style="margin-bottom: 25px">
        <el-row :gutter="10">
          <el-col :span="12">
          <el-card style="padding:8px 0">
            <h3 class="align-md">{{tipoConsulta(idAgenda)}}</h3>
          </el-card>
          </el-col>
          <el-col :span="12">
            <el-card :style="!idServico ? 'padding:8px 0' : ''">
              <h3 class="align-md">{{agendamento.especialidade.descricao}}</h3>
              <span class="title-sm align-md" v-if="idServico">{{labelTipoServico}}</span>
            </el-card>
          </el-col>
        </el-row>
        <el-card v-if="idAgenda === '1'">
          <h3>{{local.descricao}}</h3>
          <span class="title-sm" v-html="fullEndereco(local.endereco)"></span>
        </el-card>
      </div>
      <span class="title-cards">Médico</span>
      <div style="margin-bottom: 10px">
        <el-card>
          <div style="display: flex; justify-content: space-between;">
            <div>
              <h3>{{agendamento.nome}}</h3>
              <span class="title-sm">{{agendamento.conselho}}</span>
              <span class="title-sm">{{agendamento.localAtendimento.descricao}}</span>
            </div>
            <div>
            <img v-if="agendamento.urlFoto" class="img-medico" :src="agendamento.urlFoto"/>
          </div>
          </div>
        </el-card>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-card>
              <span class="title-big-bold">
                <inline-svg height="20" :fill="corIconeNavegacao + '3A'" class="svg-align" :src="require('@/assets/icons/Icon_nav_calendar.svg')"/>
                  {{formatData}}
              </span>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card>
              <span class="title-big-bold">
                <inline-svg height="20" :fill="corIconeNavegacao + '3A'" class="svg-align" :src="require('@/assets/icons/Icon_schedule_clock.svg')"/>
                {{formatHora}}</span>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <span class="title-cards">Paciente</span>
      <div>
        <el-card>
          <h3>{{paciente.nome}}</h3>
          <span class="title-sm">{{paciente.numeroContrato}} {{paciente.tipoUser}}</span>
        </el-card>
          <el-card>
            <span class="title-sm">Contato:</span>
            <h3>{{dadosContato.nome}}</h3>
            <span class="title-sm">{{dadosContato.celular}}</span>
            <span class="title-sm">{{dadosContato.email}}</span>
          </el-card>
      </div>
        <el-button  @click="confirmarConsulta" :style="`background: ${corBotaoPrincipal}; margin-top:15px`" class="btn-primary">
          <span :style="`color: ${corTextoBotaoPrincipal}`">{{ labelBotaoConfirmar }}</span>
        </el-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import InlineSvg from 'vue-inline-svg'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'
export default {
  components: {
    DialogDefault,
    InlineSvg
  },
  data () {
    return {
      erro: {
        show: false,
        titulo: 'Falha ao agendar!',
        descricao: ''
      }
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('Login', ['user']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('Func53', ['agendamento', 'idAgenda', 'local', 'paciente', 'responsavelAtendimento', 'dadosContato', 'idServico', 'tipoServico']),
    textoConfirmacao () {
      return this.funcionalidade.parametros.textos.textoInformativoConfirmarConsulta
    },
    formatData () {
      return moment(this.agendamento.dataHora).format('DD/MM/YYYY')
    },
    formatHora () {
      return moment(this.agendamento.dataHora).format('HH:mm')
    },
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    corIconeNavegacao () {
      return this.estilo.navegacao.corIconeNavegacao
    },
    labelBotaoConfirmar () {
      return this.funcionalidade.parametros.textos.labelBotaoConfimarAgendamento
    },
    labelTipoServico () {
      if (this.idServico) {
        return this.tipoServico.find(item => item.idServico === this.idServico).descricao
      }
      return ''
    }
  },
  methods: {
    ...mapActions('Func53', ['setAgendamentoSucessso']),
    tipoConsulta (id) {
      let tipo
      id === '1' ? tipo = 'Consulta presencial' : tipo = 'Teleconsulta'
      return tipo
    },
    fullEndereco (endereco) {
      return `${endereco.cidade}, ${endereco.bairro} </br> ${endereco.endereco}, ${endereco.numero}`
    },
    async confirmarConsulta () {
      const paciente = {
        chaveUnica: this.paciente.chaveUnica,
        numeroContrato: this.paciente.numeroContrato,
        integracao: this.paciente.integracao
      }
      const responsavelAtendimento = {
        chaveUnica: this.responsavelAtendimento.chaveUnica,
        numeroContrato: this.responsavelAtendimento.numeroContrato,
        integracao: this.responsavelAtendimento.integracao
      }

      const payload = {
        paciente,
        responsavelAtendimento,
        dadosContato: this.dadosContato,
        idEspecialidade: this.agendamento.especialidade.id,
        idLocal: this.agendamento.localAtendimento.id,
        idProfissional: this.agendamento.id,
        tipoAgenda: this.idAgenda,
        idAgenda: this.agendamento.idAgenda,
        dataHora: this.agendamento.dataHora
      }

      if (this.idServico) {
        payload.idServico = this.idServico
      }
      const res = await this.apiFuncionalidade.gravarConsulta({
        loading: true,
        handlerErrorIgnore: true,
        payload
      })
      if (res.status) {
        this.setAgendamentoSucessso(res.data)
        this.$router.replace({ query: { step: 7 } })
      } else {
        this.erro.descricao = res.data.message
        this.erro.show = true
      }
    }
  }
}
</script>
